module.exports = __webpack_public_path__ + "assets/img/teacher (35).5d0da3d3.png";